export default {
    name: 'RelatedAssociates',


    /**
     * @override
     */
    data() {
        return {
            associates: [],
            fields: [
                {
                    key: 'given_name',
                    label: 'Nombre'
                },
                {
                    key: 'family_name',
                    label: 'Apellidos'
                },
                {
                    key: 'document_id',
                    label: 'Nº de documento'
                },
                {
                    key: 'percent',
                    label: 'Porcentaje'
                }
            ],
            showForm: false
        };
    },
    props: {
        id: {
            type: String,
            required: false
        }
    },
    methods: {
        fetchData() {
            this.$accountsService.getAccountAssociates(this.id)
                .then(response => {
                    this.associates = response.data.account_associates;
                })
                .catch(error => console.error(error));
        }
    },

    /**
     * @override
     */
    beforeMount() {
        this.fetchData();
    }
};
